import {downloadBlobAsFile} from '@Utils/file.util';

export function resolveDocumentTitle(title?: string): string {
  if (title !== undefined && title !== '') {
    return title;
  }

  return window.i18next.t('pmwjs_pdf_document');
}

export async function downloadPdf(url: string, title?: string): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();

  downloadBlobAsFile(blob, `${resolveDocumentTitle(title)}.pdf`);
}
